/** @import Descuento from '@/classes/facturae/Descuento' */
/** @import Tax from '@/classes/facturae/Tax' */
export default class InvoiceLine {
  /** @type {string} */ codProducto = null
  /** @type {string} */ descripcion = null
  /** @type {number} */ precioUnitario = null
  /** @type {number} */ cantidad = null
  /** @type {number} */ subtotal = null
  /** @type {number} */ total = null
  /** @type {string} */ UnitOfMeasure = null
  /** @type {number} */ totalConImpuesto = null
  /** @type {number} */ lineNumber = null
  /** @type {Descuento} */ descuentos = null
  /** @type {Array<Tax>} */ taxes = null
  /** @type {String} */ AdditionalLineItemInformation = null
}
